import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";
import { useFilters } from "../Filters.hook";

const FRAGMENT_ORDERS_OPTIONS = new FragmentDefiner(
	"Filter",
	`id 
   name 
   options`
);

export const FRAGMENT_ORDERS = new FragmentDefiner(
	"Filters",
	` order {
	${FRAGMENT_ORDERS_OPTIONS.query()}
  }`
);

type useOrderProps = {
	filterChanged?: (newfilters: any) => void;
};

export const useOrder = (props: useOrderProps) => {
	const { filters, changeFilters } = useFilters();
	const { filterChanged = changeFilters } = props;

	const { loading, data, error } = useReadFragment(FRAGMENT_ORDERS_OPTIONS, "order");

	const handleChange = ({ value, text }) => {
		filterChanged({ order: { value: value, text: text }, page: null });
	};

	return {
		loading: loading,
		data: {
			onChange: handleChange,
			options: data?.options,
			value: filters?.order,
			valueKey: "text",
			customKey: "value",
		},
		error: error,
		show: true,
	};
};
